import { render, staticRenderFns } from "./changeDefaultBodyModal.vue?vue&type=template&id=0cf30662&scoped=true&"
import script from "./changeDefaultBodyModal.vue?vue&type=script&lang=ts&"
export * from "./changeDefaultBodyModal.vue?vue&type=script&lang=ts&"
import style0 from "./changeDefaultBodyModal.vue?vue&type=style&index=0&id=0cf30662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf30662",
  null
  
)

export default component.exports